import { classnames } from '@aibees/shared/utils';
import { CardContent, CardHeader } from '@mui/material';
import { memo } from 'react';
import { PeopleAnalysisUnlockCardContent } from '../people-analysis-unlock-card-content';
import { PeopleAnalysisUnlockCardTitle } from '../people-analysis-unlock-card-title';
import * as Styled from './styles';
import type { PeopleAnalysisUnlockCardProps as Props } from './types';

export const PeopleAnalysisUnlockCard = memo(
  ({ className, isPopover }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('PeopleAnalysisUnlockCard', className, {
          isPopover,
        })}
        headerDivider
        variant="outlined"
      >
        <CardHeader title={<PeopleAnalysisUnlockCardTitle />} />
        <CardContent>
          <PeopleAnalysisUnlockCardContent />
        </CardContent>
      </Styled.Wrapper>
    );
  }
);

PeopleAnalysisUnlockCard.displayName = 'PeopleAnalysisUnlockCard';
